"use client";
import styles from "./NewLists.module.scss";
import NewsCard from "@molecules/NewsCard";
import { FreeMode, Mousewheel } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";


export default function NewLists({ data, title }: any) {
  return (
    <div className={`px-3 ${styles.root}`}>
      <Swiper
        freeMode={true}
        mousewheel={{ forceToAxis: true }}
        modules={[FreeMode, Mousewheel]}
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 10
          },
          481: {
            slidesPerView: 1.2,
            spaceBetween: 16
          },
          650: {
            slidesPerView: 1.5,
            spaceBetween: 16
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          1024: {
            slidesPerView: 2.5,
            spaceBetween: 20
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 10
          },
          1440: {
            slidesPerView: 4,
            spaceBetween: 20
          },
          1900: {
            slidesPerView: 4,
            spaceBetween: 100
          }
        }}
      >
        {data?.map((d) => (
          <SwiperSlide key={d.id}>
            <NewsCard id={d.id} {...d.attributes} title={title} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
